import type { ReactNode } from 'react';

export function Mention({ children = '@카미봇' }: { children?: ReactNode }) {
  return <span className="mention">{children}</span>;
}
